import { render } from "./OnboardingFormView.vue?vue&type=template&id=45a7eec6&ts=true"
import script from "./OnboardingFormView.vue?vue&type=script&lang=ts"
export * from "./OnboardingFormView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__